import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const markTrialComplete = async ({ trialId, incompletePatientStatus }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/mark-complete/`,
    { incomplete_patient_status: incompletePatientStatus },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useMarkTrialCompleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markTrialComplete,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["summary_trial", trialId] });
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useMarkTrialCompleteMutation;
